import React, {
    useState,
    useEffect,
} from 'react';

import { getBasketData } from "../router"
import LoadingIndicator from './loading-indicator';

import * as UTILS from "../utils";

export default function BasketSummary() {

    const { data: basketData, isPending: basketDataPending } = getBasketData();

    const [deliveryAmount, setDeliveryAmount] = useState(null);
    const [basketTotal, setBasketTotal] = useState(null);

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        const delivery_amount = UTILS.getDeliveryAmount(basketData);
        setDeliveryAmount(delivery_amount);

        let basket_total = basketData.total;
        if (basketData.totalDiscount) {
            basket_total = basketData.total - basketData.totalDiscount;
        }
        if (basket_total < 0) {
            basket_total = 0;
        }
        setBasketTotal(basket_total);

    }, [basketData]);

    if (!basketData) return;
    if (basketDataPending) return <LoadingIndicator />;

    return (
        <section className='basket-summary'>
            {basketData.membershipSubscriptions.length ? 
                basketData.membershipSubscriptions.map((membership) => (
                    <p key={membership.id} className='basket-summary__item'>
                        <span>{membership.membership.name}</span>
                        <span>£{membership.price.toFixed(2)}</span>
                    </p>
                ))
                : null
            }
            {basketData.donations.length ? 
                basketData.donations.map((donation) => (
                    <p key={donation.id} className='basket-summary__item'>
                        <span>{donation.fund.name}</span>
                        <span>£{donation.amount.toFixed(2)}</span>
                    </p>
                ))
                : null
            }
            {deliveryAmount ? 
                <p className='basket-summary__item'>
                    <span>Delivery</span>
                    <span>£{deliveryAmount}</span>
                </p>
                : null
            }
            {basketData.totalDiscount ? 
                <p className='basket-summary__item'>
                    <span>Discount</span>
                    <span>-£{basketData.totalDiscount.toFixed(2)}</span>
                </p>
                : null
            }
            {basketTotal ?
                <p className='basket-summary__total'>
                    <span>Total</span>
                    <span>£{basketTotal.toFixed(2)}</span>
                </p>
                :null
            }
        </section>
    );
}